import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Flex,
  Portal,
} from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { UserProfile } from '@texas/api/endpoints/userProfilesApi';
import { defaultIconSize, Icons } from '@texas/components/shared/Icons';
import { ArchivedTooltip } from '@texas/components/shared/tooltip/ArchivedTooltip';
import { TFunction } from 'i18next';

export const TableColumns = (
  t: TFunction,
  onArchiveOpen: (profile: UserProfile) => void,
  onRestore: (profileId: number) => Promise<void>,
  onEditOpen: (profile: UserProfile) => void,
  onMergeOpen: (profile: UserProfile) => void,
  ref: React.MutableRefObject<HTMLDivElement | null>,
) => {
  const columnHelper = createColumnHelper<UserProfile>();
  const columns = [
    columnHelper.accessor('name', {
      cell: (info) => info.getValue(),
      header: 'Name',
      enableSorting: false,
    }),
    columnHelper.accessor('connectedProjectsCount', {
      cell: (info) => info.getValue(),
      header: 'Projects',
      enableSorting: false,
    }),
    columnHelper.accessor('id', {
      cell: (info) => (
        <>
          <Flex justifyContent="end" alignItems="center" gap={4}>
            {info.row.original.archived && (
              <ArchivedTooltip
                archived={info.row.original.archived.toString()}
              />
            )}
            <Menu placement="left" variant="table">
              <MenuButton float="right" aria-label={t('general.more')}>
                <Icons.DotsHorizontal boxSize={defaultIconSize} />
              </MenuButton>
              <Portal containerRef={ref}>
                <MenuList zIndex={99}>
                  {!info.row.original.archived && (
                    <>
                      <MenuItem
                        icon={<Icons.Pencil boxSize={5} />}
                        onClick={() => onEditOpen(info.row.original)}
                      >
                        {t('general.edit')}
                      </MenuItem>
                      <MenuItem
                        icon={<Icons.SwapHorizontal boxSize={5} />}
                        onClick={() => onMergeOpen(info.row.original)}
                      >
                        {t('userProfile.merge')}
                      </MenuItem>
                    </>
                  )}
                  {info.row.original.archived ? (
                    <MenuItem
                      color="texas.sand.100"
                      icon={<Icons.Undo boxSize={5} />}
                      onClick={() => onRestore(info.row.original.id)}
                    >
                      {t('general.restore')}
                    </MenuItem>
                  ) : (
                    <MenuItem
                      color="texas.sand.50"
                      icon={<Icons.Archive boxSize={5} />}
                      onClick={() => onArchiveOpen(info.row.original)}
                    >
                      {t('general.archive')}
                    </MenuItem>
                  )}
                </MenuList>
              </Portal>
            </Menu>
          </Flex>
        </>
      ),
      header: '',
      enableSorting: false,
    }),
  ];

  return columns;
};
